import React from "react";

const SET_1 = [
  ["M-200 660 C 200 480, 520 760, 820 510 S 1340 240, 1640 400", 1.6],
  ["M-200 780 C 260 580, 600 850, 920 620 S 1420 380, 1640 520", 1.1],
  ["M-200 240 C 120 120, 420 400, 720 240 S 1240 -20, 1540 130", 1.3],
  ["M180 -100 C 420 180, 820 80, 1040 380 S 1320 720, 1520 820", 1.1],
];

const SET_2 = [
  ["M-200 380 C 240 280, 540 540, 880 350 S 1340 140, 1620 260", 1],
  ["M-200 540 C 280 420, 660 660, 980 470 S 1380 280, 1620 380", 0.9],
  ["M-200 100 C 180 -20, 480 240, 800 80 S 1300 -120, 1620 30", 1.2],
  ["M-100 880 C 280 720, 640 900, 1000 760 S 1400 580, 1640 700", 0.8],
];

const Layer = ({ paths, color, opacity, cls }) => (
  <svg
    className={`absolute inset-0 h-full w-full ${cls}`}
    viewBox="0 0 1440 900"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid slice"
    style={{ opacity }}
  >
    {paths.map(([d, w]) => (
      <path key={d} d={d} stroke={color} strokeWidth={w} fill="none" strokeLinecap="round" />
    ))}
  </svg>
);

export const FlowLines = ({ color = "#3ECF9B", opacity = [0.11, 0.09] }) => (
  <div aria-hidden="true" className="flow-lines">
    <Layer paths={SET_1} color={color} opacity={opacity[0]} cls="anim-flow-1" />
    <Layer paths={SET_2} color={color} opacity={opacity[1]} cls="anim-flow-2" />
  </div>
);
